// ----------------------------------------------------------------------
export function select(theme) {
    return {
        MuiSelect: {
            styleOverrides: {
                icon: {
                    width: 20,
                    height: 20,
                    top: "calc(50% - 9px)",
                },
            },
        },
        MuiNativeSelect: {
            styleOverrides: {
                icon: {
                    width: 18,
                    height: 18,
                    top: "calc(50% - 9px)",
                },
            },
        },
    };
}
